import React from "react";
import { BsPlus } from "react-icons/bs";

import { useAppDispatch } from "../../../../app/hooks";
import { InvoicesTable } from "../InvoicesTable/InvoicesTable";
import { setShowAddInvoiceModal } from "../../ordersSlice";
import { Order } from "../../../../models";

import "./InvoicesCard.scss";

export interface InvoicesCardProps {
  order: Order;
}

export function InvoicesCard(props: InvoicesCardProps) {
  const dispatch = useAppDispatch();

  const { order } = props;

  const onAddInvoiceClick = () => dispatch(setShowAddInvoiceModal(order));

  return (
    <div className="invoices-card-component">
      <div className="header">
        <div className="header-title">Invoices</div>

        <div className="buttons-container">
          <div className="button-container" onClick={onAddInvoiceClick}>
            <BsPlus className="icon" />
            <div>Add Invoice</div>
          </div>
        </div>
      </div>

      <InvoicesTable />
    </div>
  );
}
